"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _colors = require("../colors");

var standardDimensions = {
  large: '72px',
  medium: '38px',
  small: '16px'
};
var pageCenter = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)'
};

var Spinner =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2["default"])(Spinner, _PureComponent);

  function Spinner() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2["default"])(this, Spinner);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(Spinner)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getCurrentOffset", function () {
      var duration = _this.props.duration;
      return _this.el.getCurrentTime() % duration / duration;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "renderSpinner", function () {
      var offset = _this.props.offset;
      var _this$props = _this.props,
          duration = _this$props.duration,
          size = _this$props.size;
      offset %= 1;
      var begin = (1 - offset) * duration - duration;
      return _react["default"].createElement("div", {
        className: "spinner ".concat(_this.props.className),
        style: _this.props.fullPage ? pageCenter : {}
      }, _react["default"].createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: standardDimensions[size] || standardDimensions.large,
        height: standardDimensions[size] || standardDimensions.large,
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        className: "uil-ring-alt",
        ref: function ref(el) {
          return _this.el = el;
        } // eslint-disable-line no-return-assign

      }, _react["default"].createElement("rect", {
        x: "0",
        y: "0",
        width: "100",
        height: "100",
        fill: "none",
        className: "bk"
      }), _react["default"].createElement("circle", {
        cx: "50",
        cy: "50",
        r: "40",
        stroke: _colors.alloy,
        fill: "none",
        strokeWidth: "10",
        strokeLinecap: "butt"
      }), _react["default"].createElement("circle", {
        cx: "50",
        cy: "50",
        r: "40",
        stroke: _colors.info.darkest,
        fill: "none",
        strokeWidth: "10",
        strokeLinecap: "butt"
      }, _react["default"].createElement("animate", {
        attributeName: "stroke-dashoffset",
        dur: duration,
        repeatCount: "indefinite",
        from: "0",
        to: "-502",
        begin: begin
      }), _react["default"].createElement("animate", {
        attributeName: "stroke-dasharray",
        dur: duration,
        repeatCount: "indefinite",
        values: "75.3 175.7;1 250;75.3 175.7",
        begin: begin
      }))));
    });
    return _this;
  }

  (0, _createClass2["default"])(Spinner, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.handleOffset && this.props.handleOffset(this.getCurrentOffset());
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.fullPage ? _reactDom["default"].createPortal(this.renderSpinner(), document.body) : this.renderSpinner();
    }
  }]);
  return Spinner;
}(_react.PureComponent);

exports["default"] = Spinner;
Spinner.propTypes = {
  className: _propTypes["default"].string,
  size: _propTypes["default"].oneOf(['large', 'medium', 'small']),
  duration: _propTypes["default"].number,
  offset: _propTypes["default"].number,
  handleOffset: _propTypes["default"].func,
  fullPage: _propTypes["default"].bool
};
Spinner.defaultProps = {
  size: 'large',
  className: '',
  duration: 2,
  offset: 0,
  fullPage: false
};